import React, { useEffect } from 'react';
import Hero from '@/components/home/Hero';
import About from '@/components/home/About';
import Services from '@/components/home/Services';
import WhyChoose from '@/components/home/WhyChoose';
import FeaturedProperties from '@/components/home/FeaturedProperties';
import Industries from '@/components/home/Industries';
import Process from '@/components/home/Process';
import Testimonials from '@/components/home/Testimonials';
import Stats from '@/components/home/Stats';
import Founder from '@/components/home/Founder';
import BlogPreview from '@/components/home/BlogPreview';
import ContactSection from '@/components/site/ContactSection';

export default function HomePage() {
  useEffect(() => {
    document.title = 'Cespedis Property Management & Commercial Leasing | Commercial Real Estate Hyderabad';
  }, []);
  return (
    <div data-testid="home-page">
      <Hero />
      <About />
      <Services />
      <WhyChoose />
      <FeaturedProperties />
      <Industries />
      <Process />
      <Stats />
      <Testimonials />
      <Founder />
      <BlogPreview />
      <ContactSection />
    </div>
  );
}
